import React from 'react';
import { connect } from 'react-redux';
import yup from 'yup';
import makeForm from '../makeForm';
import ContinueButton from '../ContinueButton';
import { seniority, incomeType, incomeTypeStaff, justify_incomes_options } from '../IncomeUtils';
import { declaredValueCleaveOptions } from '../../../../config';
import Form from '../../Common/Form';
import RadioGroup from '../../Common/RadioGroup';
import FormGroup from '../../Common/FormGroup';
import Input from '../../Common/Input';

const NewInputForm = ({
    values,
    handleChange,
    errors,
    coborrower,
    incomesLength,
    onSubmit,
    handleCleaveChange,
    cancelForm,
    showCancel,
    is_staff,
    placeholder,
    apptype
  }) => {
    const fixSeniority = (values.seniority === 0) ? 2 : values.seniority;
    return (
      <Form onSubmit={onSubmit}>
          <FormGroup placeholder={placeholder} label={`¿Cuánto ${coborrower ? 'gana' : 'ganás'} (en mano) por mes${!!incomesLength ? ' de este ingreso' : ''}?`}>
              <Input
                  type="tel"
                  cleaveOptions={declaredValueCleaveOptions}
                  addOn="$"
                  placeholder={placeholder}
                  value={values.income}
                  name="income"
                  onChange={handleCleaveChange}
                  validator={yup.number().typeError('').min(5000, 'El ingreso mínimo es de $ 5.000')}
                  errors={errors.income}
              />
          </FormGroup>
          <RadioGroup
              label={`¿Cómo ${coborrower ? 'percibe sus' : 'percibís tus'}  ingresos${!!incomesLength ? ' secundarios' : ''}?`}
              onChange={handleChange}
              name="income_type"
              selected={values.income_type}
              errors={errors.income_type}
              selectedCategory={values.category}
              income_type={values.income_type}
          >
              {is_staff ? incomeTypeStaff : incomeType}
          </RadioGroup>
          <RadioGroup
              label={`¿Qué antigüedad ${coborrower ? 'tiene' : 'tenés'} en ${coborrower ? 'su' : 'tu'} trabajo o situación actual?`}
              onChange={handleChange}
              name="seniority"
              selected={values.seniority}
              errors={errors.seniority}
          >
              {seniority}
          </RadioGroup>
          {(apptype === 'cp') && <RadioGroup
              label={`¿Puede presentar comprobantes de ingresos?`}
              onChange={handleChange}
              name="justify_incomes"
              selected={values.justify_incomes}
              errors={errors.justify_incomes}
          >
              {justify_incomes_options}
          </RadioGroup>}
          {is_staff &&
              <FormGroup label="Fecha de ingreso" errors={errors.starting_date}>
                  <Input
                      type="date"
                      value={values.starting_date}
                      name="starting_date"
                      onChange={handleChange}
                  />
              </FormGroup>
          }
          <div style={{ display: 'flex', justifyContent: 'center' }}>
              {showCancel && <p><a onClick={cancelForm} style={{textDecoration: 'none', color: '#18C7AF'}}>Cancelar</a></p>}
          </div>
          <ContinueButton autoFocus={false} sticky={true} disabled={values.income_type && values.income && fixSeniority ? false : true}/>
      </Form>
    );
};

const mapStateToProps = ({ user }) => ({ is_staff: !!user.is_staff })
export default connect(mapStateToProps)(makeForm(NewInputForm))
